import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useTheme } from '@mui/material';
export const Dropdown = ({ label, id, selected, value, setValue, options, error }) => {
  const [labelLocation, setLabelLocation] = React.useState(false);
  const handleChange = (event) => {
    const option = options.find((o) => o.value === event.target.value);
    setValue(option);
  };
  return (
    <Box sx={{ minWidth: 120 }} onClick={() => setLabelLocation(true)}>
      {' '}
      {/* onMouseLeave={() => setLabelLocation(false)} */}
      <FormControl fullWidth>
        <InputLabel
          id={id}
          style={{ margin: labelLocation === true ? '-8px 0 0 15px' : '8px 0 0 8px' }}
        >
          {label}
        </InputLabel>
        <Select
          error={error}
          variant="outlined"
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={selected?.value || selected?.value === 0 ? selected?.value : value || ''}
          label={label}
          onChange={handleChange}
        >
          {options?.map(({ value, label }, i) => {
            return (
              <MenuItem key={i} value={value}>
                {label}
              </MenuItem>
            );
          })}
          ;
        </Select>
        <div
          style={{
            color: '#f44336',
            marginLeft: '14px',
            fontSize: '0.75rem',
            fontFamily: 'Roboto',
          }}
        >
          {error}
        </div>
      </FormControl>
    </Box>
  );
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName?.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

export function MultipleSelect({
  label,
  id,
  selected,
  value: selectedValue,
  setValue,
  options,
  error,
}) {
  const theme = useTheme();
  const [selectedOption, setSelectedOption] = React.useState([]);
  const [labelLocation, setLabelLocation] = React.useState(false);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    setValue(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value
    );

    setSelectedOption(typeof value === 'string' ? value.split(',') : value);
  };

  return (
    <div>
      <FormControl fullWidth onClick={() => setLabelLocation(true)}>
        {' '}
        {/* onMouseLeave={() => setLabelLocation(false)} */}
        <InputLabel
          id={id}
          shrink
          style={{
            margin: labelLocation === true ? '-8px 0 0 15px' : '8px 0 0 8px',
            padding: '5px',
            backgroundColor: 'white',
            zIndex: 2,
          }}
        >
          {label}
        </InputLabel>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          variant="outlined"
          multiple
          value={selectedOption || selectedValue?.split(',')}
          onChange={handleChange}
          MenuProps={MenuProps}
        >
          {options.map(({ value, label }, i) => (
            <MenuItem key={i} value={value} style={getStyles(value, selected, theme)}>
              {label}
            </MenuItem>
          ))}
        </Select>
        <div
          style={{
            color: '#f44336',
            marginLeft: '14px',
            fontSize: '0.75rem',
            fontFamily: 'Roboto',
          }}
        >
          {error}
        </div>
      </FormControl>
    </div>
  );
}
